/**
 * Returns a File when the clipboard contains an image, otherwise null.
 */
export function fileFromClipboardImage(clipboardData) {
  if (!clipboardData?.items) return null;

  for (const item of clipboardData.items) {
    if (item.kind !== 'file' || !item.type.startsWith('image/')) continue;

    const blob = item.getAsFile();
    if (!blob) continue;

    const extension = blob.type === 'image/jpeg' ? 'jpg' : 'png';
    return new File([blob], `screenshot-${Date.now()}.${extension}`, { type: blob.type });
  }

  return null;
}
